import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const employerLocaleModule: LocaleModule = {
  name: "employer",
  messages: { en: en, it: it },
};
